import { Injectable } from '@angular/core';
import { ApiImplementation } from '../api/api-implementation.service';
import { ApiService } from '../api/api.service';
import { Paginator } from '../../models/paginator';
import { Person } from '../../models/person';


@Injectable({
  providedIn: 'root'
})
export class PeopleService extends ApiImplementation {

  protected base: string = "v1/people";
  protected primaryKey: string = "id";

  constructor(protected api: ApiService) {
    super(api)
  }

  model(data?) {
    return new Person(data);
  }

  paginator(data) {
    return new Paginator<Person>(data);
  }


  public all(limit = 100, page = 1): Promise<Paginator<Person>> {
    return super.all(limit, page) as Promise<Paginator<Person>>;
  }

  public get(id: number) {
    return super.get(id) as Promise<Person>;
  }

  public delete(person: Person) {
    return super.delete(person);
  }

  public save(person: Person): Promise<Person> {
    return super.save(person) as Promise<Person>;
  }

  public changeProfilePicture(id, file) {
    const formData: FormData = new FormData();
    formData.append('image', file);
    return this.api.post(this.base + '/' + id + '/profile-image', formData);
  }

}